import {
  featuresWithToggles,
  type FeatureToggleOptions,
  type PlatformFeatureToggles,
} from "@shared/featureToggles";

const useFeatureToggles = () => {
  const platformStore = usePlatformStore();

  return computed(() => {
    const featureToggles: PlatformFeatureToggles = {};
    const platformConfiguration =
      platformStore.tryGetPlatformConfiguration?.properties;

    Object.entries(featuresWithToggles).forEach((toggle) => {
      // Typecast because Object.entries forgets strict key types
      const [toggleName, featureTogglesOptions] = toggle as [
        keyof PlatformFeatureToggles,
        FeatureToggleOptions,
      ];

      if (platformConfiguration?.featureFlags?.[toggleName] !== undefined) {
        featureToggles[toggleName] =
          platformConfiguration?.featureFlags[toggleName];
      } else {
        // Fallback to default value if no value is set in the platform configuration
        featureToggles[toggleName] = featureTogglesOptions.default;
      }
    });

    return featureToggles as Required<PlatformFeatureToggles>;
  });
};

export default useFeatureToggles;
